import React, { useEffect, useRef, useState } from 'react';
import { FaChevronDown, FaMapMarkerAlt, FaCog, FaTimesCircle, FaBolt } from 'react-icons/fa';
import '../GridProduto/product-page-options.css';

export interface TaskPageOptionsProps {
  onQuickDirection?: () => void;
  onCustomFields?: () => void;
  onCancelTasks: () => void;
  onViewGps: () => void;
  disabled?: boolean;
}

const TaskPageOptions = ({
  onQuickDirection,
  onCustomFields,
  onCancelTasks,
  onViewGps,
  disabled = false,
}: TaskPageOptionsProps) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleOutside = (event: MouseEvent) => {
      if (rootRef.current && !rootRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, []);

  useEffect(() => {
    if (!open) return undefined;

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false);
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [open]);

  const run = (fn: () => void) => {
    setOpen(false);
    fn();
  };

  return (
    <div
      ref={rootRef}
      className={`product-page-options${open ? ' product-page-options--open' : ''}`}
    >
      <button
        type="button"
        className="product-page-options__trigger"
        onClick={() => setOpen((prev) => !prev)}
        disabled={disabled}
        aria-expanded={open}
        aria-haspopup="menu"
      >
        <span className="product-page-options__trigger-label">Opções</span>
        <FaChevronDown size={14} className="product-page-options__chevron" aria-hidden />
      </button>

      {open ? (
        <div className="product-page-options__menu" role="menu">
          {onQuickDirection ? (
            <button
              type="button"
              className="product-page-options__item"
              role="menuitem"
              onClick={() => run(onQuickDirection)}
            >
              <span className="product-page-options__item-icon" aria-hidden>
                <FaBolt size={16} />
              </span>
              <span className="product-page-options__item-text">Direcionamento Rápido</span>
            </button>
          ) : null}
          {onCustomFields ? (
            <button
              type="button"
              className="product-page-options__item"
              role="menuitem"
              onClick={() => run(onCustomFields)}
            >
              <span className="product-page-options__item-icon" aria-hidden>
                <FaCog size={16} />
              </span>
              <span className="product-page-options__item-text">Campos Customizados</span>
            </button>
          ) : null}
          <button
            type="button"
            className="product-page-options__item"
            role="menuitem"
            onClick={() => run(onCancelTasks)}
          >
            <span className="product-page-options__item-icon" aria-hidden>
              <FaTimesCircle size={16} />
            </span>
            <span className="product-page-options__item-text">Cancelar Tarefas Selecionadas</span>
          </button>
          <button
            type="button"
            className="product-page-options__item"
            role="menuitem"
            onClick={() => run(onViewGps)}
          >
            <span className="product-page-options__item-icon" aria-hidden>
              <FaMapMarkerAlt size={16} />
            </span>
            <span className="product-page-options__item-text">GPS Coletado</span>
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default TaskPageOptions;
